<template>
  <div class="vue-edit-utility-form-wrap">
    <div>
      <div class="selected-utility-container" v-if="utility">
        <!-- title -->
        <header>Edit Utility: {{utilityName}}</header>
        <!-- name -->
        <div class="controls-container selected-utility">
          <div class="control utility-name">
            <label for="utility">Name:</label>
            <input v-model="localUtility.name" placeholder="Utility name" type="text" class="name" v-bind:disabled="updatingUtiity">
          </div>
        </div>
        <!-- code -->
        <div class="controls-container selected-utility">
          <div class="control utility-code">
            <label for="utility">Code:</label>
            <input v-model="localUtility.code" placeholder="Utility code" type="text" class="code" v-bind:disabled="updatingUtiity">
          </div>
        </div>
        <!-- description -->
        <div class="controls-container selected-utility">
          <div class="control utility-description">
            <label for="utility">Description:</label>
            <input v-model="localUtility.description" placeholder="Utility description" type="text" class="description" v-bind:disabled="updatingUtiity">
          </div>
        </div>
        <!-- url -->
        <div class="controls-container selected-utility">
          <div class="control utility-description">
            <label for="utility">Url:</label>
            <input v-model="localUtility.url" placeholder="Utility url" type="text" class="url" v-bind:disabled="updatingUtiity">
          </div>
        </div>
        <!-- utility type id -->
        <div class="controls-container selected-utility">
          <div class="control utility-description">
            <label for="utility">Utility type:</label>
            <select v-model="localUtility.utilityTypeId" @change="onUtilityTypeSelectChange($event)" name="utilites">
            <option v-for="utilityType in utilityTypes" :key="utilityType.utilityTypeId" :value="utilityType.utilityTypeId">{{utilityType.name}}</option>
            </select>
          </div>
        </div>
          <!-- towns -->
          <div class="controls-container towns">
            <div class="header">Associate Towns to: <span class="utility-name">{{utilityName}}</span></div>
            <div class="add-towns-container">
              <div class="control add-town">
              <label for="utility">Add town:</label>
              <select @change="onTownSelectChange($event)" name="utilites">
                <option v-for="town in towns" :key="town.townId" :value="town.townId">{{town.name}}</option>
              </select>
              <b-button
              @click="addTown()"
              class="add"
              v-if="selectedTown && !selectedTown.updating">Associate {{selectedTown.name}} to {{utility.name}}</b-button>
              <b-spinner v-if="selectedTown && selectedTown.updating" class="ajax-spinner"></b-spinner>
              </div>
            </div>
            <div v-if="associatedTowns && associatedTowns.length" class="control associated-towns-container">
            <label for="utility">Towns associated with {{utility.name}}:</label>
            <ul class="associated-towns">
              <li v-bind:class="{deleted: associatedTown.deleted}" v-for="associatedTown in associatedTowns" :key="associatedTown.townId" :value="associatedTown.townId" class="associated-town">
                <span class="town-name">{{associatedTown.name}}</span>
                <span class="remove-button-container">
                  <b-button v-if="!associatedTown.deleting" @click="removeTown(associatedTown)"  class="remove-button">Remove {{associatedTown.name}}</b-button>
                  <b-spinner v-if="associatedTown.deleting" class="ajax-spinner"></b-spinner>
                </span>
              </li>
            </ul>
            </div>
          </div>
        <div class="buttons-container">
          <b-spinner v-if="updatingUtiity" class="ajax-spinner"></b-spinner>
          <b-button
          class="cancel"
          v-on:click="hideForm()"
          v-bind:disabled="updatingUtiity"
          v-if="!updatingUtiity && !deleteMode">Cancel</b-button>
          <b-button
          class="submit"
          v-on:click="submitUtility()"
          v-bind:disabled="updatingUtiity"
          v-if="!updatingUtiity  && !deleteMode">Update Utility</b-button>
          <span
          class="delete-button-container"
          v-if="!updatingUtiity && (!associatedTowns || !associatedTowns.length)">
            <delete-button-with-confirm
            :buttonText="'Delete ' + utility.name"
            :confirmText="'Confirm delete: ' + utility.name"
            :deleteClicked="onDeleteButtonClicked"
            :cancelClicked="onDeleteCancelButtonClicked"
            :deleteConfirmClicked="onDeleteConfirmButtonClicked"></delete-button-with-confirm>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';
import API from "@/services/api";
import DeleteButtonWithConfirm from "../../../../../shared/buttons/delete-button-with-confirm/DeleteButtonWithConfirm";

export default {
  name: 'EditUtilityForm',
  components: {
    DeleteButtonWithConfirm
  },
  props: {
      towns: Array,
      utility: Object,
      hideForm: Function,
      utilityTypes: Array,
      utilityEditSuccess: Function,
      onUtilityRemoveSuccess: Function,
  },
  data() {
    return {
      utilityName: '',
      deleteMode: false,
      updatingUtiity: false,
      associatedTowns: [],
      selectedTown: undefined,
      localUtility: {
        name: '',
        code: '',
        description: '',
        url: '',
        utilityTypeId: null
      }
    }
  },
  created() {
    this.setupUtilityDetails();
  },
  watch: {
    utility: function () {
      this.setupUtilityDetails();
    }
  },
  methods: {
    onDeleteButtonClicked() {
      this.deleteMode = true;
    },
    onDeleteCancelButtonClicked() {
      this.deleteMode = false;
    },
    onDeleteConfirmButtonClicked() {
      this.deleteUtility();
    },
    setupUtilityDetails() {
      this.utilityName = this.utility.name;
      this.localUtility = {
        name: this.utility.name || '',
        code: this.utility.code || '',
        description: this.utility.description || '',
        url: this.utility.url || '',
        utilityTypeId: this.utility.utilityTypeId || null
      };
      this.setAssociatedTowns();
    },
    setAssociatedTowns() {
      this.associatedTowns = this.utility.towns ? this.utility.towns : [];
    },
    onUtilityTypeSelectChange(event) {
      const matchingUtilityType = lodash.find(this.utilityTypes, utilityType => utilityType.utilityTypeId === parseInt(event.target.value));
      this.utilityType = matchingUtilityType ? matchingUtilityType : undefined;
      if (this.utilityType) {
        this.localUtility.utilityTypeId = this.utilityType.utilityTypeId;
      }
    },
    onTownSelectChange(event) {
      const matchingTown = lodash.find(this.towns, town => town.townId === parseInt(event.target.value));
      this.selectedTown = matchingTown ? matchingTown : undefined;
    },
    async addTown() {
      this.selectedTown.updating = true;
      this.$forceUpdate();

      try {
        API.AddTownToUtility(this.utility.utilityId, this.selectedTown.townId).then((data) => {
          this.selectedTown = undefined;
          this.$forceUpdate();
          const matchingTown = lodash.find(this.towns, town => town.townId === parseInt(data.townId));
          matchingTown.updating = false;
          if (matchingTown) {
              this.associatedTowns.push(matchingTown);
              this.$forceUpdate();
          }
        }, err => {
          console.error('addTown - ERROR');
          console.dir(err);
        })
      } catch (err) {
          this.updatingUtiity = false;
          console.error('POST ERROR!');
          console.dir(err);
      }
    },
    async removeTown(associatedTown) {
        associatedTown.deleting = true;
        this.$forceUpdate();
      try {
        API.RemoveTownFromUtility(this.utility.utilityId, associatedTown.townId).then(() => {
          associatedTown.deleting = false;
          associatedTown.deleted = true;
          this.$forceUpdate();
          const matchingTownIndex = lodash.findIndex(this.associatedTowns, town => town.townId === parseInt(associatedTown.townId));
          this.associatedTowns.splice(matchingTownIndex, 1);
          // Emit event to parent to update the utility.towns prop
          this.$emit('town-removed', associatedTown.townId);
        }, err => {
          console.error('removeTown - ERROR');
          console.dir(err);
          associatedTown.deleting = false;
          this.$forceUpdate();
        })
      } catch (err) {
          associatedTown.deleting = false;
          this.$forceUpdate();
          console.error('POST removeTown!');
          console.dir(err);
      }
    },
    deleteUtility(){
      this.updatingUtiity = true;
      try {
        API.RemoveUtility(this.utility.utilityId).then(() => {
          this.onUtilityRemoveSuccess(this.utility);
        }, err => {
          console.error('RemoveUtility - ERROR');
          console.dir(err);
          this.updatingUtiity = false;
        })
      } catch (err) {
          this.updatingUtiity = false;
          console.error('RemoveUtility - catch  - ERROR');
          console.dir(err);
      }
    },
    submitUtility(){
      this.updatingUtiity = true;
      const postData = {
        utilityId: this.utility.utilityId,
        name: this.localUtility.name,
        code: this.localUtility.code,
        description: this.localUtility.description,
        url: this.localUtility.url,
        utilityTypeId: this.localUtility.utilityTypeId
      };
      try {
        API.UpdateUtility(postData).then((data) => {
          this.updatingUtiity = false;
          this.utilityEditSuccess(data);
        }, err => {
          console.error('UpdateUtility - ERROR');
          console.dir(err);
          this.updatingUtiity = false;
          if (err
          && err.response
          && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
              this.errorMessage = `Error updating ${this.utility.name}`;
          }
          setTimeout(() => {this.fadeErrorMessage = true}, 3000);
          setTimeout(() => {
            this.errorMessage = '';
            this.fadeErrorMessage = false;
          }, 6000);
        })
      } catch (err) {
          this.updatingUtiity = false;
          console.error('POST ERROR!');
          console.dir(err);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../../assets/css/partials/_variables.scss";

.vue-edit-utility-form-wrap{
  margin-top: 20px;

  .selected-utility-container{
      header{
        margin: 10px 0 30px 5px;
        font-weight: $bold;
        color: $black;
      }

    .controls-container {
      width: 80%;
      margin-bottom: 20px;
      padding: 10px;
      background-color: $modalGrey;

      input[type="text"] {
        width: 100%;
        height: 40px;
        padding-left: 10px;
        border: none;
      }

      .header{
        margin: 10px 0 0 5px;
        font-weight: bold
      }

      &.utility-select{
        select{
          margin-left: 5px;
        }
      }

      &.selected-utility{
        margin-top: 10px;
      }

      label {
        display: block;
        margin-right: 10px;
        font-weight: bold;
      }

      &.towns{
        .ajax-spinner{
          position: relative;
          height: 24px;
          width: 24px;
          top: 2px;
          left: 10px;
          color: #fbd850;
        }

        button{
          &.add{
            margin-left: 10px;

            &:hover{
              background-color: #3d683c;
            }
          }
        }
      }

      .add-towns-container{
        margin-left: 10px;
        padding: 10px;
      }

      .associated-towns-container{
        margin-left: 10px;
        padding: 10px;

        .associated-towns{
          max-height: 500px;
          overflow-y: scroll;

          .associated-town{
            position: relative;
            margin-top: 5px;
            padding: 15px;
            background-color: #fff;

            &.deleted{
              display: none;
            }

            .remove-button-container{
                position: absolute;
                top: 10px;
                right: 10px;

              .remove-button{
                  &:hover{
                    color: #fff;
                    background-color: #800000;
                  }
              }
            }

            .ajax-spinner{
              top: -3px;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .buttons-container{
      margin-top: 20px;

      .ajax-spinner{
        color: #fbd850;
      }

      button{
        margin-right: 10px;
      }
    }
  }
}
</style>
